import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminRecordedSchema } from "./common.js";
/** How much we keep, where, and how long until the disk is full. */
export const adminStorageSchema = z.object({
    disk: z.object({ usedMb: adminCountSchema, totalMb: adminCountSchema }),
    objectStoreMb: adminCountSchema,
    /** Evidence of workspaces that no longer exist: kept, on purpose. */
    deletedWorkspacesMb: adminCountSchema,
    answersStored: adminCountSchema,
    growthMbPerWeek: adminRecordedSchema(adminCountSchema),
    daysToFull: adminRecordedSchema(adminCountSchema),
    growth: z.array(z.object({ weekStart: adminDaySchema, objectStoreMb: adminCountSchema })),
    byWorkspace: z.array(z.object({ name: z.string(), mb: adminCountSchema })),
});
//# sourceMappingURL=storage.js.map